import { createRoutine } from 'redux-saga-routines';

export const fetchTicketsV2Summary = createRoutine('FETCH_TICKETS_V2_SUMMARY');
export const getAllTickets = createRoutine('GET_ALL_TICKETS');
export const getTicket = createRoutine('GET_TICKET');
export const patchTicket = createRoutine('PATCH_TICKET');
export const markTicketAsSeen = createRoutine('MARK_TICKET_AS_SEEN');
export const fetchAllMessages = createRoutine('FETCH_ALL_MSGS');
export const createMsgForTicket = createRoutine('SEND_MSG_FOR_TICKET');
export const fetchAllParticipants = createRoutine('FETCH_ALL_PARTICIPANTS');
export const fetchTicketHistory = createRoutine('FETCH_TICKET_HISTORY');
export const loadMoreTicketHistory = createRoutine('LOAD_MORE_TICKET_HISTORY');
export const postTicketMentions = createRoutine('POST_TICKET_MENTIONS');
export const fetchAllTicketStatuses = createRoutine(
  'FETCH_ALL_TICKET_STATUSES'
);
export const fetchAllTicketPriorities = createRoutine(
  'FETCH_ALL_TICKET_PRIORITIES'
);
export const updateTicketsListRefreshTs = createRoutine(
  'UPDATE_TICKETS_LIST_REFRESH_TS'
);
export const fetchTicketsByEntityV2 = createRoutine(
  'FETCH_TICKETS_BY_ENTITY_V2'
);
export const clearTicketsByEntityV2 = createRoutine('CLEAR_TICKETS_V2');
export const loadMoreTicketsByEntityV2 = createRoutine(
  'LOAD_MORE_TICKETS_BY_ENTITY_V2'
);
export const uploadTicketAttachment = createRoutine('UPLOAD_TICKET_ATTACHMENT');
